<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="row gap-y align-items-center">
          <div class="col-6 col-lg-3">
            <a href="index.html">
              <img :src="logoImage" alt="logo" />
            </a>
          </div>

          <div class="col-6 col-lg-3 text-right order-lg-last">
            <div class="social">
              <a class="social-facebook" href="https://www.facebook.com/amsainfotech/?modal=admin_todo_tour" target="_blank">
                <i class="fa fa-facebook"></i>
              </a>
               <a class="social-linkedin" href="https://www.linkedin.com/company/amsa-infotech-pvt-ltd">
                <i class="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="nav nav-bold nav-uppercase nav-trim justify-content-lg-center">
              <a class="nav-link custom" @click="goToAboutPage()">About</a>
              <a class="nav-link custom" @click="goToContactPage()">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import logoImage from '../assets/img/logo/300px.png';

export default {
  data: () => ({
    logoImage,
  }),
  methods: {
    goToAboutPage() {
      this.$router.push('/about');
    },
    goToContactPage() {
      this.$router.push('/contact');
    },
  },
};
</script>
<style>
.custom {
  cursor: pointer;
}
</style>

